import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import Home from '@/views/home/Home.vue'
import Login from "@/views/login/Login";
import store from '@/store';
import {User} from "@/entity/User";
import api from "@/services/apiService";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    meta: {
      requireLogged: true,
      requireDisconnected: false,
      requireAdmin: false,
    },
    component: Home,
  },
  {
    path: '/login/:token?',
    name: 'Login',
    meta: {
      requireLogged: false,
      requireDisconnected: true,
      requireAdmin: false,
    },
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/Login.vue'),
  },
  {
    path: '/reservations',
    name: 'ReservationList',
    meta: {
      requireLogged: true,
      requireDisconnected: false,
      requireAdmin: false,
    },
    component: () => import(/* webpackChunkName: "reservation-list" */ '@/views/reservation-list/ReservationList.vue'),
  },
  {
    path: '/reservation/view/:id',
    alias: ['/reservation/edit/:id', '/reservation/new/:id'],
    name: 'ReservationDetail',
    meta: {
      requireLogged: true,
      requireDisconnected: false,
      requireAdmin: false,
    },
    component: () => import(/* webpackChunkName: "reservation-detail" */ '@/views/reservation-detail/ReservationDetail.vue'),
  },
  {
    path: '/parameters',
    name: 'Parameters',
    meta: {
      requireLogged: true,
      requireDisconnected: false,
      requireAdmin: false,
    },
    component: () => import(/* webpackChunkName: "parameters" */ '@/views/parameters/Parameters.vue'),
  },
  {
    path: '/administration',
    name: 'Administration',
    meta: {
      requireLogged: true,
      requireDisconnected: false,
      requireAdmin: true,
    },
    component: () => import(/* webpackChunkName: "administration" */ '@/views/administration/Administration.vue'),
  },
];

const router = new VueRouter({
  routes: routes,
  base: '/',
  mode: 'history',
});

async function tryAuthenticate() {
  if (!localStorage.user || localStorage.user == "undefined") {
    localStorage.setItem('user', JSON.stringify(new User()));
    return false;
  }

  const localData = JSON.parse(localStorage.user);
  if (localData.email && localData.email.length > 0) { // Pas connecté sur l'app mais informations dans localStorage, donc peut être connecté côté serveur
    try {
      const response = await api.apiRequest.post('login');
      store.commit('login', JSON.parse(localStorage.user));
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  } else {
    return false;
  }
}

router.beforeEach(async (to, from, next) => {

  // Prévenir la personne de quitter la page pendant une action importante
  if (store.state.confirmBeforeLeaving.needToBlock) {
    if (!window.confirm("Êtes-vous certain de vouloir quitter la page ? Certaines données peuvent être perdues")) {
      return;
    }
  }

  // Autorisation d'accès aux routes
  const requireLogged = to.matched.some(record => record.meta.requireLogged);
  const requireDisconnected = to.matched.some(record => record.meta.requireDisconnected);
  const requireAdmin = to.matched.some(record => record.meta.requireAdmin);


  if (!store.getters.isAuthenticated) {
    await tryAuthenticate();
  }
  const isConnected = store.getters.isAuthenticated;
  const isAdmin = store.getters.isAdmin;

  if (requireAdmin) {
    isAdmin ? next() : next({name: 'Home'});
  }


  if (requireLogged) {
    isConnected ? next() : next({name: 'Login'});
  }
  if (requireDisconnected) {
    isConnected ? next({name: 'Home'}) : next();
  }

});

router.afterEach((to, from) => {
  store.commit('pushToHistory', to.path);
});

export default router
